<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-formulario #ctrl URL="articulos" titulo="Artículos / Catalogo" [dato]="dato"></app-formulario>

<!-- Menu principal  menutitulo="titulo del modulo en el que estamos con el nombre como se encuentra en enviroment" menuactual="nombre del hub donde estamos como se especifico en el routing"-->
<app-sistema-menu menutitulo="Catalogo" menuactual="catalogo"></app-sistema-menu>

<div class="contenedor columns " style="height:100%; ">

    <div class="column is-2 is-hidden-mobile menu-izquierda">

        <!-- Menu izquierda menutitulo="titulo del modulo enviroment" -->
        <app-sistema-menu-aside menuactual="Catalogo"></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; ">

            <!-- inicio formulario -->
            <form name="form" novalidate [formGroup]="dato" (ngSubmit)="ctrl.enviar()">
                <section class="hero is-primary">
                    <div class="hero-body">

                        <!-- Opciones  -->
                        <app-formulario-opciones [ctrl]="ctrl" [id]="ctrl.dato.id"></app-formulario-opciones>
                    </div>
                </section>
                <div class="is-fullwidth has-text-centered" *ngIf="!ctrl.datosCargados">
                    <br>
                    <span class="tag is-primary is-large ">
                        <span class="icon">
                            <i class="icon-worldwide fa-spin"></i>
                        </span> &nbsp;
                        <span>Cargando...</span>
                    </span>
                </div>

                <section class="section" style="padding: 1rem !important; overflow:auto; height: 85.8vh;" >

                    <!-- cargar los catalogos que se requieran parametro 1 modelo donde se guarda el catalogo, parametro 2 ruta de la api -->
                    <a id="catalogos" (click)="ctrl.iniciar_derecha('i'); ctrl.iniciar_izquierda('i'); ctrl.cargarCatalogo('categorias', 'categoria'); ctrl.cargarCatalogo('presentaciones', 'presentacion');
                    ctrl.cargarCatalogo('unidades_medidas', 'unidad-medida'); ctrl.cargarCatalogo('catalogos_impuestos', CFDI_PATH+'/api/v1/catalogo-impuesto'); ctrl.cargarCatalogo('catalogos_factores',
                    CFDI_PATH+'/api/v1/catalogo-factor')"></a>
                    <div class="contenedor columns ">

                        <div class="column">

                            <div class="tabs is-boxed" style="margin-top: -10px;">

                                <!-- se crea los tab se debe definir una variable llamada tab en el .ts con un valor por default ejemplo tab=1 -->
                                <ul>
                                    <li [ngClass]="{ 'is-active' : tab == 1}">
                                        <a (click)="tab=1">
                                            <span class="icon is-small is-right">
                                                <i class="icon-file"></i>
                                            </span>
                                            <span>General</span>
                                        </a>
                                    </li>

                                    <li [ngClass]="{ 'is-active' : tab == 6}">
                                        <a (click)="tab=6">
                                            <span class="icon is-small is-right">
                                                <i class="fa fa-dollar"></i>
                                            </span>
                                            <span>Precios</span>
                                        </a>
                                    </li>

                                    <li [ngClass]="{ 'is-active' : tab == 5}">
                                        <a (click)="tab=5">
                                            <span class="icon is-small is-right">
                                                <i class="fa fa-file-picture-o"></i>
                                            </span>
                                            <span>Imágenes</span>
                                        </a>
                                    </li>
                                    <li [ngClass]="{ 'is-active' : tab == 9}">
                                        <a (click)="tab=9">
                                            <span class="icon is-small is-right">
                                                <i class="fa fa-picture-o"></i>
                                            </span>
                                            <span>Galeria</span>
                                        </a>
                                    </li>

                                    <li [ngClass]="{ 'is-active' : tab == 8}">
                                        <a (click)="tab=8">
                                            <span class="icon is-small is-right">
                                                <i class="icon-file"></i>
                                            </span>
                                            <span>Facturación</span>
                                        </a>
                                    </li>

                                </ul>
                            </div>

                            <div [ngClass]="{ 'is-hidden': tab != 1}">
                                <!-- GENERAL -->
                                <div class="columns">


                                    <div class="column is-6">
                                        <label class="label">Presentación:</label>
                                        <div class="select">
                                            <select class="select" name="presentaciones_id" formControlName="presentaciones_id">
                                                <option *ngFor="let val of ctrl.presentaciones" value="{{val.id}}">{{ val.nombre }}</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="column is-6">
                                        <label class="label">Unidad de medida:</label>
                                        <div class="select">
                                            <select class="select" name="unidades_medidas_id" formControlName="unidades_medidas_id">
                                                <option *ngFor="let val of ctrl.unidades_medidas" value="{{val.id}}">{{ val.nombre }}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div class="columns">
                                    <div class="column is-3">
                                        <label class="label">Clave:</label>
                                        <p class="control has-icons-left has-icons-right">
                                            <input class="input" type="text" [ngClass]="{'is-danger': ctrl.dato.get('clave').hasError('required') && ctrl.dato.get('clave').hasError('required')}"
                                                placeholder="Clave" formControlName="clave">
                                            <span class="icon is-small is-right" *ngIf="ctrl.dato.get('clave').hasError('required') && ctrl.dato.get('clave').hasError('required')">
                                                <i class="fa fa-warning"></i>
                                            </span>
                                            <span class="help is-danger" *ngIf="ctrl.dato.get('clave').hasError('required') && ctrl.dato.get('clave').hasError('required')">Este campo es requerido.</span>
                                        </p>
                                    </div>
                                    <div class="column is-9">
                                        <label class="label">Nombre:</label>
                                        <p class="control has-icons-left has-icons-right">
                                            <input class="input" type="text" [ngClass]="{'is-danger': ctrl.dato.get('nombre').hasError('required') }" placeholder="nombre"
                                                formControlName="nombre">
                                            <span class="icon is-small is-right" *ngIf="ctrl.dato.get('nombre').hasError('required') ">
                                                <i class="fa fa-warning"></i>
                                            </span>
                                            <span class="help is-danger" *ngIf="ctrl.dato.get('nombre').hasError('required') ">Este campo es requerido.</span>
                                        </p>
                                    </div>
                                </div>



                                <div class="columns">
                                    <div class="column is-3" formGroupName="articulos_maximos_minimos">
                                        <label class="label">Stock minimo:</label>
                                        <p class="control has-icons-left has-icons-right">
                                            <input class="input" type="number" min="1" placeholder="Stock minimo" formControlName="minimo" [ngClass]="{'is-danger': ctrl.dato.get('articulos_maximos_minimos').get('minimo').hasError('required') }">
                                            <span class="icon is-small is-right" *ngIf="ctrl.dato.get('articulos_maximos_minimos').get('minimo').hasError('required') ">
                                                <i class="fa fa-warning"></i>
                                            </span>
                                            <span class="help is-danger" *ngIf="ctrl.dato.get('articulos_maximos_minimos').get('minimo').hasError('required') ">Este campo es requerido.</span>
                                        </p>
                                    </div>
                                    <div class="column is-3" formGroupName="articulos_maximos_minimos">
                                        <label class="label">Stock maximo:</label>
                                        <p class="control has-icons-left has-icons-right">
                                            <input class="input" type="number" min="{{ctrl.dato.get('articulos_maximos_minimos').value.minimo + 1}}" placeholder="Stock maximo"
                                                formControlName="maximo" [ngClass]="{'is-danger': ctrl.dato.get('articulos_maximos_minimos').get('maximo').hasError('required') }">
                                            <span class="icon is-small is-right" *ngIf="ctrl.dato.get('articulos_maximos_minimos').get('maximo').hasError('required') ">
                                                <i class="fa fa-warning"></i>
                                            </span>
                                            <span class="help is-danger" *ngIf="ctrl.dato.get('articulos_maximos_minimos').get('maximo').hasError('required') ">Este campo es requerido.</span>
                                        </p>
                                    </div>
                                    <div class="column is-3">
                                        <label class="label">Cantidad por envase:</label>
                                        <p class="control has-icons-left has-icons-right">
                                            <input class="input" type="number" [ngClass]="{'is-danger': ctrl.dato.get('cantidad_x_envase').hasError('required')}" placeholder="Cantidad por envase"
                                                formControlName="cantidad_x_envase">
                                            <span class="icon is-small is-right" *ngIf="ctrl.dato.get('cantidad_x_envase').hasError('required')">
                                                <i class="fa fa-warning"></i>
                                            </span>
                                            <span class="help is-danger" *ngIf="ctrl.dato.get('cantidad_x_envase').hasError('required')">Este campo es requerido.</span>
                                        </p>
                                    </div>
                                    <div class="column is-3">
                                        <br>
                                        <br>
                                        <div class="b-checkbox is-info">
                                            <input id="es_fraccionable" class="styled" type="checkbox" formControlName="es_fraccionable">
                                            <label for="es_fraccionable">
                                                Es fraccionable?
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="columns">
                                    <div class="column is-6">
                                        <label class="label">Código de barras:</label>
                                        <p class="control has-icons-left has-icons-right">
                                            <input class="input" type="text" placeholder="Código de barras" formControlName="codigo_barras">
                                        </p>
                                    </div>
                                    <div class="column is-3">
                                        <label class="label">Peso:</label>
                                        <p class="control has-icons-left has-icons-right">
                                            <input class="input" type="number" formControlName="peso">
                                        </p>
                                    </div>
                                    <div class="column is-3">
                                        <label class="label">Material:</label>
                                        <p class="control has-icons-left has-icons-right">
                                            <input class="input" type="text" formControlName="material">
                                        </p>
                                    </div>
                                </div>
                                <div class="columns">
                                    <div class="column is-2">
                                        <br>
                                        <div class="barcode bcode">
                                            <ngx-barcode [bc-value]="ctrl.dato.get('codigo_barras').value" [bc-display-value]="true"></ngx-barcode>

                                        </div>
                                    </div>
                                    <div class="column is-10">
                                        <div class="field">
                                            <label class="label">Descripción:</label>
                                            <div class="control">
                                                <textarea class="textarea" maxlength="255" rows="4" placeholder="Descripción" formControlName="descripcion">
                                                                            </textarea>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>

                            <div [ngClass]="{ 'is-hidden': tab != 6}">
                                <!-- PRECIOS -->
                                <div class="columns">
                                    <div class="column is-6">
                                        <label class="label">Costo:</label>
                                        <p class="control has-icons-left has-icons-right">
                                            <input class="input" type="number" [ngClass]="{'is-danger': ctrl.dato.get('costo').hasError('required')}" placeholder="Costo"
                                                formControlName="costo" (change)="cambiar_precios()" (keyup)="cambiar_precios()">
                                            <span class="icon is-small is-right" *ngIf="ctrl.dato.get('costo').hasError('required')">
                                                <i class="fa fa-warning"></i>
                                            </span>
                                            <span class="help is-danger" *ngIf="ctrl.dato.get('costo').hasError('required')">Este campo es requerido.</span>
                                        </p>
                                    </div>
                                    <div class="column is-6">
                                        <label class="label">Porcentaje de utilidad:</label>
                                        <p class="control has-icons-left has-icons-right">
                                            <input class="input" type="number" [ngClass]="{'is-danger': ctrl.dato.get('porcentaje_utilidad').hasError('required')}" placeholder="Porcentaje de utilidad"
                                                formControlName="porcentaje_utilidad" (change)="cambiar_precios()" (keyup)="cambiar_precios()">
                                            <span class="icon is-small is-right" *ngIf="ctrl.dato.get('porcentaje_utilidad').hasError('required')">
                                                <i class="fa fa-warning"></i>
                                            </span>
                                            <span class="help is-danger" *ngIf="ctrl.dato.get('porcentaje_utilidad').hasError('required')">Este campo es requerido.</span>
                                        </p>
                                    </div>
                                </div>
                                <table class="table is-striped  is-fullwidth" *ngIf="ctrl.dato.get('articulos_precios').length > 0">
                                    <thead>
                                        <tr>
                                            <th hide-sm>ID</th>
                                            <th>Nombre</th>
                                            <th>Precio</th>
                                            <th>Porcentaje descuento</th>
                                            <th>Activo</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody formArrayName="articulos_precios">
                                        <tr *ngFor="let precio of ctrl.dato.controls.articulos_precios.controls; let p=index" [formGroupName]="p">
                                            <td>{{ p + 1 }}</td>
                                            <td>
                                                <p class="control">
                                                    <input class="input" type="text" placeholder="Nombre" formControlName="nombre">
                                                    <span class="help is-danger" *ngIf="!ctrl.dato.controls.articulos_precios.controls[p].controls.nombre.valid && ctrl.dato.controls.articulos_precios.controls[p].controls.nombre.hasError('required')">Este campo es requerido.</span>
                                                </p>
                                            </td>
                                            <td>
                                                <p class="control">
                                                    <input class="input" type="number" placeholder="Precio" formControlName="precio" (change)="cambio_precio(precio)" (keyup)="cambio_precio(precio)">
                                                    <span class="help is-danger" *ngIf="!ctrl.dato.controls.articulos_precios.controls[p].controls.precio.valid && ctrl.dato.controls.articulos_precios.controls[p].controls.precio.hasError('required')">Este campo es requerido.</span>
                                                </p>
                                            </td>
                                            <td>
                                                <p class="control">
                                                    <input class="input" type="number" placeholder="Porcentaje utilidad" formControlName="porcentaje_utilidad" (change)="cambio_utilidad(precio)"
                                                        (keyup)="cambio_utilidad(precio)">
                                                    <span class="help is-danger" *ngIf="!ctrl.dato.controls.articulos_precios.controls[p].controls.porcentaje_utilidad.valid && ctrl.dato.controls.articulos_precios.controls[p].controls.porcentaje_utilidad.hasError('required')">Este campo es requerido.</span>
                                                </p>
                                            </td>
                                            <td>
                                                <br>
                                                <div class="field">
                                                    <div class="b-checkbox is-circular is-info">
                                                        <input id="activo-p-{{p}}" value="1" name="activo" [checked]="ctrl.dato.get('articulos_precios').value[p].activo == 1 ? true : false"
                                                            formControlName="activo" class="styled" type="radio">
                                                        <label for="activo-p-{{p}}">
                                                            Activo
                                                        </label>
                                                    </div>
                                                </div>
                                            </td>
                                            <td align="right">
                                                <button type="button" class="button is-danger" (click)="ctrl.quitar_form_array(ctrl.dato.controls.articulos_precios, p)">
                                                    <i class="icon-trash"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <div style="background: rgba(127, 220, 42, 0.62); width:100%; padding: 10px; margin-top: -20px;">
                                    <button type="button" class="button is-default" (click)="ctrl.agregar_form_array(ctrl.dato.controls.articulos_precios, form_articulos_precios)">
                                        <i class="icon-add2"></i>
                                    </button>

                                    <button type="button" class="button is-info" (click)="agregar_precios_default(ctrl.dato.controls.articulos_precios)">
                                        <i class="fa fa-check"></i>
                                    </button>
                                </div>
                            </div>

                            <div [ngClass]="{ 'is-hidden': tab != 2}">
                                <!-- DESCUENTOS -->

                                <span formArrayName="articulos_descuentos" *ngIf="ctrl.dato.get('articulos_descuentos').length > 0">
                                    <nav class="panel" *ngFor="let descuento of ctrl.dato.controls.articulos_descuentos.controls; let d=index" [formGroupName]="d">
                                        <p class="panel-heading">
                                            Descuento # {{ d + 1 }}

                                            <button style="margin-top: -5px; float:right" type="button" class="button is-danger" (click)="ctrl.quitar_form_array(ctrl.dato.controls.articulos_descuentos, d)">
                                                <i class="icon-trash"></i>
                                            </button>
                                        </p>
                                        <div class="panel-block">
                                            <div style="width:100%">
                                                <div class="columns">
                                                    <div class="column is-6">
                                                        <p class="control">
                                                            <input class="input" type="text" placeholder="Nombre" formControlName="nombre">
                                                            <span class="help is-danger" *ngIf="!ctrl.dato.controls.articulos_descuentos.controls[d].controls.nombre.valid && ctrl.dato.controls.articulos_descuentos.controls[d].controls.nombre.hasError('required')">Este campo es requerido.</span>
                                                        </p>
                                                    </div>
                                                    <div class="column is-4">
                                                        <p class="control">
                                                            <input class="input" id="porcentaje_descuento{{d}}" name="porcentaje_descuento-d" type="number" min="1" max="99" placeholder="Porcentaje descuento"
                                                                formControlName="porcentaje_descuento">
                                                            <span class="help is-danger" *ngIf="!ctrl.dato.controls.articulos_descuentos.controls[d].controls.porcentaje_descuento.valid && ctrl.dato.controls.articulos_descuentos.controls[d].controls.porcentaje_descuento.hasError('required')">Este campo es requerido.</span>
                                                        </p>
                                                    </div>
                                                    <div class="column is-2">
                                                        <br>
                                                        <div class="field">
                                                            <div class="b-checkbox is-circular is-info">
                                                                <input id="activo-d-{{d}}" name="activo" value="1" [checked]="ctrl.dato.get('articulos_descuentos').value[d].activo" formControlName="activo"
                                                                    class="styled" type="radio">
                                                                <label for="activo-d-{{d}}">
                                                                    Activo
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="columns">
                                                    <div class="column is-6">
                                                        <p class="control">
                                                            <input class="input" formControlName="inicio_vigencia" date-only="true" placeholder="Inicio Vigencia(YYYY-MM-DD)" />
                                                            <span class="help is-danger" *ngIf="!ctrl.dato.controls.articulos_descuentos.controls[d].controls.inicio_vigencia.valid && ctrl.dato.controls.articulos_descuentos.controls[d].controls.inicio_vigencia.hasError('required')">Este campo es requerido.</span>
                                                        </p>
                                                    </div>
                                                    <div class="column is-6">
                                                        <p class="control">
                                                            <input class="input" formControlName="fin_vigencia" date-only="true" placeholder="Fin Vigencia(YYYY-MM-DD)" />
                                                            <span class="help is-danger" *ngIf="!ctrl.dato.controls.articulos_descuentos.controls[d].controls.fin_vigencia.valid && ctrl.dato.controls.articulos_descuentos.controls[d].controls.fin_vigencia.hasError('required')">Este campo es requerido.</span>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </nav>
                                </span>

                                <div style="background: rgba(127, 220, 42, 0.62); width:100%; padding: 10px; margin-top: 20px;">
                                    <button type="button" class="button is-default" (click)="ctrl.agregar_form_array(ctrl.dato.controls.articulos_descuentos, form_articulos_descuentos)">
                                        <i class="icon-add2"></i>
                                    </button>
                                </div>

                            </div>

                            <div [ngClass]="{ 'is-hidden': tab != 3}">
                                <!-- PROMOCIONES -->

                                <span formArrayName="articulos_promociones" *ngIf="ctrl.dato.get('articulos_promociones').length > 0">
                                    <nav class="panel" *ngFor="let promocion of ctrl.dato.controls.articulos_promociones.controls; let pr=index" [formGroupName]="pr">
                                        <p class="panel-heading">
                                            Promoción {{ pr + 1 }}

                                            <button style="margin-top: -5px; float:right" type="button" class="button is-danger" (click)="ctrl.quitar_form_array(ctrl.dato.controls.articulos_promociones, pr)">
                                                <i class="icon-trash"></i>
                                            </button>
                                        </p>
                                        <div class="panel-block">
                                            <div style="width:100%">
                                                <div class="columns">
                                                    <div class="column is-6">
                                                        <p class="control">
                                                            <input class="input" type="text" placeholder="Nombre" formControlName="nombre">
                                                            <span class="help is-danger" *ngIf="!ctrl.dato.controls.articulos_promociones.controls[pr].controls.nombre.valid && ctrl.dato.controls.articulos_promociones.controls[pr].controls.nombre.hasError('required')">Este campo es requerido.</span>
                                                        </p>
                                                    </div>
                                                    <div class="column is-6">
                                                        <!--<label class="label">Tipo de promoción:</label>
                                                    -->
                                                        <div class="select">
                                                            <select class="select" name="tipo_promocion" formControlName="tipo_promocion">
                                                                <option value="NULL" selected>Seleccionar tipo de promoción</option>
                                                                <option value="1">POR # DE ARTICULOS COMPRADOS</option>
                                                                <option value="2">POR MONTO DE COMPRA EN UN ARTICULO</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="columns" [ngClass]="{ 'is-hidden': ctrl.dato.controls.articulos_promociones.controls[pr].controls.tipo_promocion.value != 1}">
                                                    <div class="column is-6">
                                                        <p class="control">
                                                            <input class="input" type="number" placeholder="Cantidad minima de articulos" formControlName="cantidad_minima">
                                                            <span class="help is-danger" *ngIf="!ctrl.dato.controls.articulos_promociones.controls[pr].controls.cantidad_minima.valid && ctrl.dato.controls.promociones.controls[pr].controls.cantidad_minima.hasError('required')">Este campo es requerido.</span>
                                                        </p>
                                                    </div>
                                                    <div class="column is-6">
                                                        <p class="control">
                                                            <input class="input" type="number" placeholder="Cantidad a cobrar por articulo" formControlName="cantidad_cobrar">
                                                            <span class="help is-danger" *ngIf="!ctrl.dato.controls.articulos_promociones.controls[pr].controls.cantidad_cobrar.valid && ctrl.dato.controls.promociones.controls[pr].controls.cantidad_cobrar.hasError('required')">Este campo es requerido.</span>
                                                        </p>
                                                    </div>
                                                </div>

                                                <div class="columns" [ngClass]="{ 'is-hidden': ctrl.dato.controls.articulos_promociones.controls[pr].controls.tipo_promocion.value != 2}">
                                                    <div class="column is-6">
                                                        <p class="control">
                                                            <input class="input" type="number" placeholder="Monto minimo de articulo" formControlName="monto_minimo">
                                                            <span class="help is-danger" *ngIf="!ctrl.dato.controls.articulos_promociones.controls[pr].controls.monto_minimo.valid && ctrl.dato.controls.promociones.controls[pr].controls.monto_minimo.hasError('required')">Este campo es requerido.</span>
                                                        </p>
                                                    </div>
                                                    <div class="column is-6">
                                                        <p class="control">
                                                            <input class="input" id="porcentaje_descuento{{pr}}" name="porcentaje_descuento-pr" type="number" placeholder="Porcentaje de descuento"
                                                                formControlName="porcentaje_descuento">
                                                            <span class="help is-danger" *ngIf="!ctrl.dato.controls.articulos_promociones.controls[pr].controls.porcentaje_descuento.valid && ctrl.dato.controls.promociones.controls[pr].controls.porcentaje_descuento.hasError('required')">Este campo es requerido.</span>
                                                        </p>
                                                    </div>
                                                </div>

                                                <div class="columns">
                                                    <div class="column is-4">
                                                        <br>
                                                        <div class="field">
                                                            <div class="b-checkbox is-info">
                                                                <input id="es-acumulable-pr{{pr}}" name="es-acumulable-pr" class="styled" type="checkbox" formControlName="es_acumulable">
                                                                <label for="es-acumulable-pr{{pr}}">
                                                                    Es acumulable
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="column is-4">
                                                        <br>
                                                        <div class="field">
                                                            <div class="b-checkbox is-info">
                                                                <input id="con-otros-descuentos-pr{{pr}}" name="con-otros-descuentos-pr" class="styled" type="checkbox" formControlName="con_otros_descuentos">
                                                                <label for="con-otros-descuentos-pr{{pr}}">
                                                                    Aplica con otros descuentos
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="column is-4">
                                                        <br>
                                                        <div class="field">
                                                            <div class="b-checkbox is-circular is-info">
                                                                <input id="activo-pr-{{pr}}" name="activo" value="1" [checked]="ctrl.dato.get('articulos_promociones').value[pr].activo"
                                                                    formControlName="activo" class="styled" type="radio">
                                                                <label for="activo-pr-{{pr}}">
                                                                    Activo
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </nav>
                                </span>

                                <div style="background: rgba(127, 220, 42, 0.62); width:100%; padding: 10px; margin-top: 20px;">
                                    <button type="button" class="button is-default" (click)="ctrl.agregar_form_array(ctrl.dato.controls.articulos_promociones, form_articulos_promociones)">
                                        <i class="icon-add2"></i>
                                    </button>
                                </div>

                            </div>

                            <div [ngClass]="{ 'is-hidden': tab != 4}">
                                <!-- CUPONES -->

                                <span formArrayName="articulos_cupones" *ngIf="ctrl.dato.get('articulos_cupones').length > 0">
                                    <nav class="panel" *ngFor="let cupon of ctrl.dato.controls.articulos_cupones.controls; let cu=index" [formGroupName]="cu">
                                        <p class="panel-heading">
                                            Cupón # {{ cu + 1 }}

                                            <button style="margin-top: -5px; float:right" type="button" class="button is-danger" (click)="ctrl.quitar_form_array(ctrl.dato.controls.articulos_cupones, cu)">
                                                <i class="icon-trash"></i>
                                            </button>
                                        </p>
                                        <div class="panel-block">
                                            <div style="width:100%">
                                                <div class="columns">
                                                    <div class="column is-6">
                                                        <p class="control">
                                                            <input class="input" type="text" placeholder="Código" formControlName="codigo">
                                                            <span class="help is-danger" *ngIf="!ctrl.dato.controls.articulos_cupones.controls[cu].controls.codigo.valid && ctrl.dato.controls.articulos_cupones.controls[cu].controls.codigo.hasError('required')">Este campo es requerido.</span>
                                                        </p>
                                                    </div>
                                                    <div class="column is-4">
                                                        <p class="control">
                                                            <input class="input" type="number" min="1" max="99" placeholder="Porcentaje descuento" formControlName="porcentaje_descuento">
                                                            <span class="help is-danger" *ngIf="!ctrl.dato.controls.articulos_cupones.controls[cu].controls.porcentaje_descuento.valid && ctrl.dato.controls.articulos_cupones.controls[cu].controls.porcentaje_descuento.hasError('required')">Este campo es requerido.</span>
                                                        </p>
                                                    </div>
                                                    <div class="column is-2">
                                                        <br>
                                                        <div class="field">
                                                            <div class="b-checkbox is-info">
                                                                <input id="con-otros-descuentos-cu{{cu}}" name="con-otros-descuentos-cu" class="styled" type="checkbox" formControlName="con_otros_descuentos">
                                                                <label for="con-otros-descuentos-cu{{cu}}">
                                                                    Aplica con otros descuentos
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="columns">
                                                    <div class="column is-6">
                                                        <p class="control">
                                                            <input class="input" formControlName="inicio_vigencia" date-only="true" placeholder="Inicio Vigencia(YYYY-MM-DD)" />
                                                            <span class="help is-danger" *ngIf="!ctrl.dato.controls.articulos_cupones.controls[cu].controls.inicio_vigencia.valid && ctrl.dato.controls.articulos_cupones.controls[cu].controls.inicio_vigencia.hasError('required')">Este campo es requerido.</span>
                                                        </p>
                                                    </div>
                                                    <div class="column is-6">
                                                        <p class="control">
                                                            <input class="input" formControlName="fin_vigencia" date-only="true" placeholder="Fin Vigencia(YYYY-MM-DD)" />
                                                            <span class="help is-danger" *ngIf="!ctrl.dato.controls.articulos_cupones.controls[cu].controls.fin_vigencia.valid && ctrl.dato.controls.articulos_cupones.controls[cu].controls.fin_vigencia.hasError('required')">Este campo es requerido.</span>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </nav>
                                </span>

                                <div style="background: rgba(127, 220, 42, 0.62); width:100%; padding: 10px; margin-top: 20px;">
                                    <button type="button" class="button is-default" (click)="ctrl.agregar_form_array(ctrl.dato.controls.articulos_cupones, form_articulos_cupones)">
                                        <i class="icon-add2"></i>
                                    </button>
                                </div>

                            </div>

                            <div [ngClass]="{ 'is-hidden': tab != 5}">
                                <!-- IMAGENES -->


                                <table class="table is-striped  is-fullwidth" *ngIf="ctrl.dato.get('articulos_imagenes').length > 0">
                                    <thead>
                                        <tr>
                                            <th hide-sm>#</th>
                                            <th>Imagen</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody formArrayName="articulos_imagenes">
                                        <tr *ngFor="let imagen of ctrl.dato.controls.articulos_imagenes.controls; let im=index" [formGroupName]="im">
                                            <td>{{ im + 1 }}</td>
                                            <td>
                                                <img [src]="imagen.value.imagen.length>150 ? 'data:image/jpg;base64,'+imagen.value.imagen : ctrl.API_PATH+'/adjunto/articulos/'+imagen.value.imagen"
                                                    width="100px">

                                                <div class="control has-icons-left has-icons-right" *ngIf="ctrl.dato.controls.articulos_imagenes.controls[im].controls.imagen.value == ''">

                                                    <div class="file has-name">
                                                        <label class="file-label">
                                                            <input type="file" class="file-input" (change)="ctrl.seleccionarImagenBase64($event, ctrl.dato.controls.articulos_imagenes.controls[im].controls.imagen)"
                                                                accept="image/x-png,image/gif,image/jpeg,image/jpg">
                                                            <input foto type="hidden" formControlName="imagen">
                                                            <span class="file-cta">
                                                                <span class="file-icon">
                                                                    <i class="fa fa-upload"></i>
                                                                </span>
                                                                <span class="file-label">
                                                                    Seleccionar archivo
                                                                </span>
                                                            </span>

                                                        </label>
                                                    </div>
                                                </div>



                                                <button type="button" class="button is-danger" (click)="ctrl.borrarImagen($event, ctrl.dato.controls.articulos_imagenes.controls[im].controls.imagen, 'articulos')"
                                                    *ngIf="ctrl.dato.controls.articulos_imagenes.controls[im].controls.imagen.value != ''">

                                                    <span class="icon ">
                                                        <i class="icon-trash"></i>
                                                    </span>
                                                    &nbsp; Eliminar la foto

                                                </button>

                                            </td>
                                            <td align="right">
                                                <button type="button" class="button is-danger" (click)="ctrl.quitar_form_array(ctrl.dato.controls.articulos_imagenes, im)">
                                                    <i class="icon-trash"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <!-- borrarImagen( par1, 'articulos')-->

                                <div style="background: rgba(127, 220, 42, 0.62); width:100%; padding: 10px; margin-top: -20px;">
                                    <button type="button" class="button is-default" (click)="ctrl.agregar_form_array(ctrl.dato.controls.articulos_imagenes, form_articulos_imagenes)">
                                        <i class="icon-add2"></i>
                                    </button>
                                </div>

                            </div>

                            <div [ngClass]="{ 'is-hidden': tab != 9}">
                                <button class="button" type="button" (click)="select_mostrar_galeria()">
                                    <span class="icon">
                                        <i class="icon-eye2 fa-2x"></i>
                                    </span>
                                    &nbsp; Recargar galeria
                                </button>
                                
                            </div>



                            <div [ngClass]="{ 'is-hidden': tab != 8}">

                                <label class="label">Seleccione la clave de producto o servicio correspondiente del cátalogo del SAT:</label>
                                <div class="field is-grouped" style=" width: 100%; ">
                                    <div class="control has-icons-left is-expanded">
                                        <input autofocus autocomplete="off" ngui-auto-complete [source]="observableSource.bind(this)" [list-formatter]="autocompleListFormatter" [close-on-focusout]="false"
                                            id='buscarArticulo' value-property-name="clave" display-property-name="nombre" path-to-data=""
                                            loading-text="Cargando..." no-match-found-text="No hay resultados." (valueChanged)="seleccionarValorSelect2($event)"
                                            min-chars="3" class="input is-success is-medium" type="text" placeholder="Escribe la calve o el nombre del producto/servicio">
                                        <span class="icon is-medium is-left">
                                            <i class="icon-search3"></i>
                                        </span>
                                    </div>
                                </div>

                                <div class="field">
                                    <label class="label">Clave de producto o servicio SAT:</label>
                                    <p class="control has-icons-left has-icons-right">
                                        <input class="input" autofocus type="text" [ngClass]="{'is-danger': ctrl.dato.get('clave_prod_serv').hasError('required') }"
                                            placeholder="Clave de producto o servicio" formControlName="clave_prod_serv" readonly>
                                        <span class="icon is-small is-right" *ngIf="ctrl.dato.get('clave_prod_serv').hasError('required') ">
                                            <i class="fa fa-warning"></i>
                                        </span>
                                        <span class="help is-danger" *ngIf="ctrl.dato.get('clave_prod_serv').hasError('required') ">Este campo es requerido.</span>
                                    </p>
                                </div>

                                <div class="field">
                                    <label class="label">SKU (No. de identificación:</label>
                                    <p class="control">
                                        <input class="input" type="text" placeholder="SKU" formControlName="sku">
                                    </p>
                                </div>

                            </div>

                            <div [ngClass]="{ 'is-hidden': tab != 10}">
                                <!-- IMPUESTOS -->
                                <div formGroupName="articulos_impuestos">
                                    <nav class="panel" formArrayName="traslados">
                                        <p class="panel-heading">
                                            Impuestos trasladados
                                        </p>
                                        <div class="panel-block" *ngFor="let impuesto of ctrl.dato.controls.articulos_impuestos.controls.traslados.controls; let i = index;">
                                            <table class="table is-striped  is-fullwidth" [formGroupName]="i">
                                                <thead>
                                                    <tr>
                                                        <th>{{i+1}}</th>
                                                        <th>Impuesto:
                                                            <div class="select">
                                                                <select class="select" formControlName="clave" (change)="seleccionarValorSelect(impuesto.get('clave').value, impuesto, ctrl.catalogos_impuestos);">
                                                                    <option *ngFor="let val of ctrl.catalogos_impuestos" value="{{val.clave}}">({{val.clave}}) {{ val.nombre }}</option>
                                                                </select>
                                                            </div>
                                                        </th>
                                                        <th>Factor:
                                                            <div class="select">
                                                                <select class="select" formControlName="factor">
                                                                    <option *ngFor="let val of ctrl.catalogos_factores" value="{{val.nombre}}">{{ val.nombre }}</option>
                                                                </select>
                                                            </div>
                                                        </th>
                                                        <th>Cuota:
                                                            <input class="input" type="text" formControlName="cuota" id="cuota_tras{{i}}">
                                                        </th>
                                                        <td align="right">
                                                            <button type="button" class="button is-danger" (click)="ctrl.quitar_form_array(ctrl.dato.controls.articulos_impuestos.controls.traslados, i)">
                                                                <i class="icon-trash"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                </thead>
                                            </table>

                                        </div>
                                        <div class="panel-block">
                                            <button type="button" class="button is-default" (click)="ctrl.agregar_form_array(ctrl.dato.controls.articulos_impuestos.controls.traslados, form_articulos_impuestos)">
                                                <i class="icon-add2"></i>
                                            </button>
                                        </div>
                                    </nav>

                                    <nav class="panel" formArrayName="retenciones">
                                        <p class="panel-heading">
                                            Impuestos retenciones
                                        </p>
                                        <div class="panel-block" *ngFor="let impuesto of ctrl.dato.controls.articulos_impuestos.controls.retenciones.controls; let i = index;">
                                            <table class="table is-striped  is-fullwidth" [formGroupName]="i">
                                                <thead>
                                                    <tr>
                                                        <th>{{i+1}}</th>
                                                        <th>Impuesto:
                                                            <div class="select">
                                                                <select class="select" formControlName="clave" (change)="seleccionarValorSelect(impuesto.get('clave').value, impuesto, ctrl.catalogos_impuestos);">
                                                                    <option *ngFor="let val of ctrl.catalogos_impuestos" value="{{val.clave}}">({{val.clave}}) {{ val.nombre }}</option>
                                                                </select>
                                                            </div>
                                                        </th>
                                                        <th>Factor:
                                                            <div class="select">
                                                                <select class="select" formControlName="factor">
                                                                    <option *ngFor="let val of ctrl.catalogos_factores" value="{{val.nombre}}">{{ val.nombre }}</option>
                                                                </select>
                                                            </div>
                                                        </th>
                                                        <th>Cuota:
                                                            <input class="input" type="text" formControlName="cuota" id="cuota_ret{{i}}">
                                                        </th>
                                                        <td align="right">
                                                            <button type="button" class="button is-danger" (click)="ctrl.quitar_form_array(ctrl.dato.controls.articulos_impuestos.controls.retenciones, i)">
                                                                <i class="icon-trash"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                </thead>
                                            </table>

                                        </div>
                                        <div class="panel-block">
                                            <button type="button" class="button is-default" (click)="ctrl.agregar_form_array(ctrl.dato.controls.articulos_impuestos.controls.retenciones, form_articulos_impuestos)">
                                                <i class="icon-add2"></i>
                                            </button>
                                        </div>
                                    </nav>
                                </div>
                            </div>

                        </div>
                    </div>

                    <!-- fin formulario -->
                </section>


            </form>
        </div>
    </div>
</div>
